import fetch from '../Services/fetch'

export default () => async (dispatch) => {

  dispatch(fetch())
  
}
